export default function createAndDownloadFile(content: string, fileType: string, fileName: string): void {
  const blob = new Blob([content], { type: fileType });

  const link = document.createElement('a');

  link.download = fileName;
  link.href = URL.createObjectURL(blob);
  link.dataset.downloadurl = [fileType, link.download, link.href].join(':');
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  link.remove();

  setTimeout(() => {
    URL.revokeObjectURL(link.href);
  }, 1500);
}
